// extracted by mini-css-extract-plugin
export default {"wrapper":"Question_wrapper__KpChc","label":"Question_label__Sr4fz","question":"Question_question__YjwNa","arrow":"Question_arrow__XcKzi","answer":"Question_answer__3+3tI"};